module.exports = __webpack_public_path__ + "img/purchase_price_icon@2x.9423305a.png";